import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "API/auth";
import {
  AnimatedLink,
  ErrorNotification,
} from "components/styles/smallComponents";
import {
  Bottom,
  Form,
  Input,
  InputControl,
  Label,
  Submit,
  Title,
} from "pages/auth/data";
import { FRONTEND_ENDPOINTS } from "Theconstants";
import { contactoInputs } from "./data";
import styled from "styled-components";
import { ContainerGral1500 } from "components/SmallComponents/Containers";
import { useAppDispatch, useAppSelector, userSelector } from "context/store";

export const Textarea = styled.textarea`
  width: 100%;
  transition: 0.3s ease-out;
  padding: 10px;
  font-size: inherit;
`;

export interface ContactoPageInputs {
  asunto: string;
  nombre: string;
  email: string;
}

const asuntoString: keyof Pick<ContactoPageInputs, "asunto"> = "asunto";

export const Contacto = () => {
  const [contactoInput, setContactoInput] = useState<ContactoPageInputs>({
    asunto: "",
    nombre: "",
    email: "",
  });
  const { loading, error } = useAppSelector(userSelector);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    //CALL BACKEND TO SEND EMAIL, loading we can use the gral one, success we just dispatch a notification
    await authAPI.contactSeller(dispatch, contactoInput);
    //poner boton de volver a atras e ir a inicio, seguir de compras, etc
  }

  function handleChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    return setContactoInput({
      ...contactoInput,
      [e.target.name]: e.target.value,
    });
  }

  return (
    <ContainerGral1500>
      <Form onSubmit={handleSubmit}>
        <ErrorNotification show={error}>{error}</ErrorNotification>
        <Title>FORMULARIO CONTACTO</Title>
        {contactoInputs.map((i) => {
          const { id, label } = i;
          return (
            <InputControl key={id}>
              <Label htmlFor={id}>{label}</Label>
              <Input
                as="input"
                id={id}
                placeholder={label}
                name={id}
                value={contactoInput[id]}
                onChange={handleChange}
              ></Input>
            </InputControl>
          );
        })}
        <InputControl>
          <Label htmlFor={asuntoString}>Asunto *</Label>
          <Textarea
            rows={4}
            id={asuntoString}
            value={contactoInput.asunto}
            name={asuntoString}
            onChange={handleChange}
          ></Textarea>
        </InputControl>
        <InputControl>
          {/*@ts-ignore - since I changed the btn to an input, the text key doesnt work, I have to use value */}
          <Submit
            as="input"
            type="submit"
            value={loading ? "Enviando mensaje..." : "Enviar mensaje"}
            disabled={loading}
          />
        </InputControl>

        <InputControl style={{ letterSpacing: "2px" }}>
          <br />
          <em>Envianos tu consulta y a la brevedad te vamos a responder.</em>
        </InputControl>
        <Bottom>
          <AnimatedLink as={"div"} onClick={() => navigate(-1)}>
            Volver
          </AnimatedLink>{" "}
          <AnimatedLink
            to={FRONTEND_ENDPOINTS.HOME}
            c="var(--mainGreen)"
            ch="var(--mainGreen)"
          >
            Inicio
          </AnimatedLink>
        </Bottom>
      </Form>
    </ContainerGral1500>
  );
};
